/**
 * Stone Investment Pagination
 *
 * Stone-themed wrapper for the core Pagination component.
 * Applies greyscale palette, square corners, editorial typography,
 * and Stone's luxury aesthetic via CSS overrides.
 */

'use client';

import { Pagination, type PaginationProps } from '@/components/ui/Pagination';

export type StonePaginationProps = PaginationProps & {
  messages?: Record<string, unknown>;
};

export function StonePagination({
  messages,
  labels,
  ...props
}: StonePaginationProps) {
  const stoneMessages = (messages?.stone || {}) as Record<string, unknown>;
  const paginationMessages = (stoneMessages.pagination || {}) as Record<string, string>;

  const resolvedLabels = {
    previous: labels?.previous || paginationMessages.previous || 'Previous',
    next: labels?.next || paginationMessages.next || 'Next',
    first: labels?.first || paginationMessages.first || 'First',
    last: labels?.last || paginationMessages.last || 'Last',
  };

  return (
    <div className="stone-pagination">
      <Pagination
        {...props}
        labels={resolvedLabels}
      />

      <style jsx global>{`
        .stone-pagination nav {
          font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .stone-pagination button {
          border-radius: 0 !important;
          font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          letter-spacing: 0.05em;
          transition: all 0.3s ease;
        }

        .stone-pagination button:not(:disabled):hover {
          background-color: rgb(245 245 244) !important;
          border-color: rgb(168 162 158) !important;
        }

        .stone-pagination button[aria-current="page"] {
          background-color: rgb(28 25 23) !important;
          color: white !important;
          border-color: rgb(28 25 23) !important;
          box-shadow: none !important;
        }

        .stone-pagination button:disabled {
          opacity: 0.3;
        }
      `}</style>
    </div>
  );
}

export default StonePagination;
